import * as SelectItem from 'types/_general/SelectItem';

export type Type = SelectItem.Type[];

export function create(): Type {
	return [];
}

export function filterSuggested(all: Type, searchTerm: string, inUseIds: string[]): Type {
	return all
		.filter((e) => !inUseIds.map((x) => x.split(':')[0]).includes(e.id.split(':')[0]))
		.filter((e) => e.name.toLowerCase().includes(searchTerm.toLowerCase()));
}

export function mapFromStringArray(all: Type, saved: string[]): Type {
	return all.filter((x) => saved.includes(x.id));
}

export function getById(obj: Type, id: string | null): SelectItem.Type | undefined {
	return obj.find((e) => e.id === id);
}

export function getNameById(obj: Type, id: string | null): string | undefined {
	return getById(obj, id)?.name ?? undefined;
}

export function getSourceById(obj: Type, id: string | null): string | undefined {
	return getById(obj, id)?.source ?? undefined;
}
